import tw from 'twin.macro'

export const blurText = tw`blur-md select-none`
export const blurTextWithMargin = tw`blur-md select-none mx-px-24 `
